import React from 'react';
import { useInView } from 'react-intersection-observer';
import '../styles/Contact.css';

const Contact = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <section id="contact" className="contact-section section-spacing">
      <div className="container-custom">
        <div ref={ref} className={`contact-content ${inView ? 'visible' : ''}`}>
          <div className="contact-header">
            <h2 className="section-title">Entre em Contato</h2>
            <div className="divider" style={{ margin: '40px auto' }}></div>
            <p className="contact-intro">
              Adoraríamos falar com você. Sinta-se à vontade para entrar em contato.
            </p>
          </div>

          <div className="contact-grid">
            <div className="contact-item">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                </svg>
              </div>
              <h3>Telefone</h3>
              <a href="tel:+5519974085161">(19) 9 7408-5161</a>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <h3>Email</h3>
              <a href="mailto:contato@tratty.com.br">contato@tratty.com.br</a>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
              </div>
              <h3>Instagram</h3>
              <a href="https://www.instagram.com/trattyprofessionals" target="_blank" rel="noopener noreferrer">@trattyprofessionals</a>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
                </svg>
              </div>
              <h3>Website</h3>
              <a href="https://www.tratty.com.br" target="_blank" rel="noopener noreferrer">tratty.com.br</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
